import React from 'react';
import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

const AuthLogin = Loadable(lazy(() => import('../views/Login/PythonLogin')));
// const AuthLogin = Loadable(lazy(() => import('../views/Login')));
// const AuthRegister = Loadable(lazy(() => import('../views/Register')));

// ==============================|| AUTHENTICATION ROUTES ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <AuthLogin />
  // children: [
  //   {
  //     path: '/login',
  //     element: <AuthLogin />
  //   },
  //   {
  //     path: '/register',
  //     element: <AuthRegister />
  //   }
  // ]
};

export default AuthenticationRoutes;
